"use strict";
;

(function() {
    var DateUtils = {
        getCurrentYearDateString: function(dt, options) {
            if (Object.prototype.toString.call(dt) !== '[object Date]'
                || isNaN(dt.getTime()) ) {
                return '(unknown)';
            }
            options = options || {};

            const months = options.monthFormat === 'long'
                ? ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
            let suffix = 'th';
            switch ( dt.getDate() ) {
                case 1:
                case 21:
                case 31:
                    suffix = 'st';
                    break;
                case 2:
                case 22:
                    suffix = 'nd';
                    break;
                case 3:
                case 23:
                    suffix = 'rd';
                    break;
            }
            return months[dt.getMonth()] + ' ' + dt.getDate() + suffix;
        }
    };

    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = DateUtils;
    } else {
        window.DateUtils = DateUtils;
}
})();